<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
     <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4" label="Tarikh Agihan *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <w-input class="mt4" label="Isipadu (cm/cm3)*" type="number" v-model="form.isipadu" :validators="[validators.required]"/>
            <z-select class="mt4" :items="aiman" label="Nama Pemohon *"  v-model="form.pemohon_id"  :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input
              class="mb2"
              label="Nama Penerima *"
              label-position="inside"
              inner-icon-right="wi-search"
              v-model="form.penerima_nama" @click="pengguna()" :validators="[validators.required]">
            </w-input>
           
            <w-input class="mt4" label="No. Kad Pengenalan" type="text" v-model="form.no_pagihan" />
          </div>
        </div>
       <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3'])">
           <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
            </w-button>
          &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
     </z-page>
     <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Pilih Nama Penerima 
      </template>

      <w-form 
         ref="form" 
         v-model="dialog.valid"
         @validate="submit"
         @success="success"
      >
          <w-flex justify-center align-center>
              <div class="xs8">
                  <w-input
                      label="No id | Nama"
                      v-model="carian_profil.q"
                  >
                  </w-input>
              </div>
              <div class="xs4">
                  <w-button class="ml1" @click="cariProfil">Cari</w-button>

                  <w-button 
                      class="ml1" 
                      @click="tambahPrfile()"
                      v-if="$zutil.anyRole(['1', '3'])"
                      >
                      TAMBAH
                  </w-button>
              </div>
          </w-flex>
        <div class="w-table-wrap" style="max-height: 400px;">
          <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left">Nama</th>
                <!-- <th class="w-table__header  text-left">Email</th> -->
                <th class="w-table__header  text-left">Nombor Telefon</th>
                <th class="w-table__header  text-left">Pilih</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="user_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in user_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" >{{dt.label}}</td>
                  <!-- <td class="w-table__cell text-left" >{{dt.email}}</td> -->
                  <td class="w-table__cell text-left" >{{dt.no_tel}}</td>
                  <td class="w-table__cell text-center">
                    <template v-if="form.pembekal_id == dt.value">
                       <w-radio
                        class="mr2"
                        v-model="form.pembekal_id"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                    <template v-else>
                      <w-radio
                        class="mr2"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>

                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
      </w-form>
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
    <w-dialog
      v-model="dialog_add.show"
      :fullscreen="dialog_add.fullscreen"
      :width="dialog_add.width"
      :persistent="dialog_add.persistent"
      :persistent-no-animation="dialog_add.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Tambah Nama Penerima
      </template>

      <w-form 
         ref="form" 
         v-model="dialog_add.valid"
         @validate="submitProfil"
         @success="success"
      >
      <div class="spacer"></div>
        <w-flex wrap :gap="2">
          <!-- <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="No. Kad Pengenalan *"
           class="mt3"
           type="text"
           placeholder="No. Kad Pengenalan"
           name="no_id"
           v-model="form_profil.no_id"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
            outline
            label="Emel *"
            class="mt3"
            type="email"
            placeholder="Sila Masukkan Emel"
            name="email"
            v-model="form_profil.email"
            :validators="[validators.required, validators.email]"
         />
          </div> -->
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="Nama Penuh *"
           class="mt3"
           type="text"
           placeholder="Nama Penuh"
           name="name"
           v-model="form_profil.name"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
             outline
             label="Nombor Telefon *"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Nombor Telefon"
             name="no_tel"
             v-model="form_profil.no_tel"
             :validators="[validators.required, validators.numeric]"
         />
          </div>
        </w-flex>
      </w-form>
        

    
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_add.show = false">TUTUP</w-button>
         <w-button 
         class="ml1" 
         :loading="dialog_add.loading"
         :disabled="dialog_add.valid === false"
         @click="$refs.form.validate()"
         >
           SIMPAN
         </w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_aiman :[Array, Object],
    // d_user_list :[Array, Object],

    
  },
  data() {
    return {
      resourceurl: 'tangki.pengagihan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Cecair Nitrogen', route: '/tangki' },
        { label: 'Pengagihan Cecair', route: '/tangki/pengagihan' },
      ],
      title : 'Pengagihan',
      form : this.d_form,
      negeri : this.d_negeri,
      status : this.d_status,
      carian_profil: { q: "" },
      country : [],
      bandar : [],
      poskod : [],
      negara : [],
      peran : [],
      form_profil: [],
      user_list:[],
      aiman: this.d_aiman,
      wajib : 0,
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      
    }
  },

  methods: {
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('tangki.pengagihan.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('tangki.pengagihan.show',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('tangki.pengagihan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('tangki.pengagihan.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('tangki.pengagihan.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },

     tambahPrfile(){
      this.form_profil = {
           id : null,
           no_id : null,
           name : null,
           email:'',
           no_tel: '',
           alamat: '',
           password: 123123,
           
           status : 1,
           kode: '',
           lkp_poskod_id: '',
           lkp_bandar_id : '',
           lkp_negeri_id :'',
           penerima:1,
      }
      this.dialog_add.show = true
      this.form_profil.saveButton = "Save"
    },

     submitProfil(){
      this.$zcomm.post('pengguna',this.form_profil).then(res => {
          if (res == "No. Kad Pengenalan sudah wujud!" || res == "Email sudah wujud!") {
            if (res == "No. Kad Pengenalan sudah wujud!")
                {
                  this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                }
            if (res == "Email sudah wujud!")
                {
                  this.$zutil.notify("Email sudah wujud!", false);
                }
          }else{
            this.$zutil.notify("Berjaya disimpan");
            this.getUserList();
            this.dialog_add.show = false;
          }
        })
        .catch(err => {
        })
    },
    pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form.saveButton = "Save"
    },

    pilihProfil(dt) {
        this.form.penerima_id = dt.value;
        this.form.penerima_nama = dt.label;
        this.dialog.show = false
    },

    cariProfil() {
        if (this.carian_profil.q.length > 1) {
            this.$zcomm
                .get(
                    this.api_service + "lookup/user_list/4",
                    this.carian_profil,
                    {}
                )
                .then((res) => {
                    this.user_list = res;
                });
        }
    },

    getUserList(){
      this.$zcomm.get(this.api_service + 'lookup/user_list/4', {}).then(res => {
        this.user_list = res
      })
    },
    

   tutup(){
         this.$inertia.visit(window.route('tangki.pengagihan.index'));
       },
    



    
  },

  watch: {

  },
  mounted() {

    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pengagihan Tangki'
    }
    else
    {
      this.title = 'Tambah Pengagihan LN2'
    }
  }
 
    
}
</script>
